import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from '@ui/auth';
import { deactivateUserAccount, getGetCurrentUserQueryKey, getGetUserProfileSettingsQueryKey, updateUserProfileSettings } from 'ze-sdk';
export function useUpdateSettings() {
    const queryClient = useQueryClient();
    const queryKey = getGetUserProfileSettingsQueryKey();
    const currentUserQueryKey = getGetCurrentUserQueryKey();
    return useMutation({
        mutationFn: (data)=>updateUserProfileSettings(data),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
            await queryClient.invalidateQueries({
                queryKey: currentUserQueryKey
            });
        }
    });
}
export function useRemoveProfile() {
    const queryClient = useQueryClient();
    const queryKey = getGetUserProfileSettingsQueryKey();
    return useMutation({
        mutationFn: ()=>deactivateUserAccount(),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
            await logout(queryClient);
        }
    });
}
